import React, { Component } from 'react';
import editorZoneStyles from './editor-zone.less.js';
import { Surface } from '../surface/surface.js';
import { EnvContext } from '../../controllers/workbench/context.js';

class Grid extends Component {
    render() {
        var _a, _b, _c, _d, _e;
        const splited = ((_b = (_a = this.props.grids) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0;
        const gridProps = {
            id: `grid-${this.props.id}`,
            className: `${editorZoneStyles.grid} ${this.props.className} grid-${this.props.type}`,
            style: this.props.style,
        };
        const children = splited
            ? (_c = this.props.grids) === null || _c === void 0 ? void 0 : _c.map((grid, _, grids) => React.createElement(Grid, Object.assign({ mode: this.props.mode, key: grid.id, style: { width: `${100 / grids.length}%` }, isHidden: this.props.type === 'stack' ? this.props.stackCurrent !== grid.id : false }, grid)))
            : (_d = this.props.surfaces) === null || _d === void 0 ? void 0 : _d.map(surface => (React.createElement(Surface, Object.assign({ mode: this.props.mode, show: surface.visible, key: surface.id }, surface))));
        const gridStyle = (_e = this.props.style) !== null && _e !== void 0 ? _e : {};
        if (this.props.isHidden) {
            gridStyle.display = 'none';
        }
        return (children
            ? React.createElement("div", Object.assign({}, gridProps, { style: gridStyle }), children)
            : null);
    }
}
Grid.contextType = EnvContext;
Grid.defaultProps = {
    className: '',
};

export { Grid };
//# sourceMappingURL=grid.js.map
